import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const Input = React.forwardRef(
  (
    {
      id,
      name,
      value,
      handleChange,
      onChange,
      placeholder,
      type,
      maxlength,
      onFocus,
      onBlur,
      disabled,
      className = "",
      controlled = false,
      height = 60,
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = type === "password";
    const inputType = isPassword && showPassword ? "text" : type;

    return (
      <div className="position-relative w-100">
        <input
          ref={ref}
          name={name}
          id={id}
          placeholder={placeholder}
          type={inputType}
          onChange={onChange || handleChange}
          onBlur={onBlur}
          defaultValue={controlled ? undefined : value}
          value={controlled ? value : undefined}
          className={`input-blue text-dark w-100  border fw-light rounded ${className}`}
          max={maxlength}
          maxLength={maxlength}
          onFocus={onFocus}
          disabled={disabled}
          onWheel={(e) => e.target.blur()}
          style={{ height: `${height}px` }}
        />

        {isPassword && (
          <span
            className="position-absolute top-50 end-0 translate-middle-y pe-3 cursor-pointer "
            onClick={() => setShowPassword(!showPassword)}
            style={{ cursor: "pointer" }}
          >
            {showPassword ? (
              <EyeOff size={20} strokeWidth="1" color="black" />
            ) : (
              <Eye size={20} strokeWidth="1" color="black" />
            )}
          </span>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
